import { SecondarySideBarType3 } from "app/components/sidebar3/types";
import { ACTIVATION_ROOT_URL } from "app/pages/activation/routing/constants";
import { Alerts } from "app/pages/activation-alerts/AlertsRoot";
import { AlertsRootContainer } from "app/pages/activation-alerts/AlertsRootContainer";
import { DEFAULT_TAB } from "app/pages/activation-alerts/components/tabs/config";
import { ACTIVATION_ALERTS_ROOT_ROUTE, ACTIVATION_ALERTS_ROUTE } from "app/pages/activation-alerts/routes/constants";
import { onRedirectToAlerts } from "app/pages/activation-alerts/routes/onRedirectToAlerts";
import { redirectPipe } from "app/routes/handlers/redirectFunctions/redirectPipe";

import { CONFIG_ID, PACKAGE_NAME, SECONDARY_BAR_TYPE } from "./constants";

export const alertsConfig = {
    [ACTIVATION_ALERTS_ROOT_ROUTE]: {
        abstract: true,
        url: ACTIVATION_ROOT_URL,
        component: AlertsRootContainer,
        packageName: PACKAGE_NAME,
        configId: CONFIG_ID,
        configIdDeps: ["WebAnalysis", "MobileWeb", "MobileWebWorldwide"],
        secondaryBarType: SECONDARY_BAR_TYPE,
        hideFromRecents: true,
    },
    [ACTIVATION_ALERTS_ROUTE]: {
        url: `/alerts/:key/:country/:duration/:webSource?alertsType&isDurationChanged&tab&viewMode`,
        component: Alerts,
        configId: CONFIG_ID,
        configIdDeps: ["WebAnalysis", "MobileWeb", "MobileWebWorldwide"],
        pageId: {
            section: "alerts",
            subSection: "alerts page",
        },
        params: {
            duration: {
                dynamic: true,
            },
            isDurationChanged: {
                type: "bool",
                dynamic: true,
                inherit: false,
            },
            tab: {
                dynamic: true,
                inherit: false,
                defaultValue: DEFAULT_TAB,
            },
            alertsType: {
                dynamic: true,
                inherit: false,
            },
            viewMode: {
                dynamic: true,
                inherit: false,
            },
        },
        trackingId: {
            section: "alerts",
            subSection: "alerts page",
            subSubSection: "alerts main",
        },
        redirectTo: redirectPipe(onRedirectToAlerts()),
        pageTitle: "activation.page.alerts.title",
        isSecondaryBarOpen: false,
        secondaryBarType: SECONDARY_BAR_TYPE,
        secondaryBarType3: SecondarySideBarType3.Activation,
        hideSecondaryBar3: true,
        hideFromRecents: true,
        isPrimarySidebarAlwaysOpen: true,
        reloadOnSearch: false,
    },
};
